var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShoppingCart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.84961 3.0001C1.84961 2.36497 2.36448 1.8501 2.99961 1.8501H5.9997C6.50539 1.8501 6.95174 2.18043 7.09951 2.66405L8.35079 6.75919H20.9996C21.3405 6.75919 21.6638 6.91043 21.8823 7.1721C22.1008 7.43377 22.192 7.77889 22.1312 8.11432L20.5738 16.7052C20.4746 17.2523 19.9982 17.6501 19.4422 17.6501H9.05742C8.50143 17.6501 8.02506 17.2523 7.92587 16.7053L6.38018 8.18073L5.1486 4.1501H2.99961C2.36448 4.1501 1.84961 3.63523 1.84961 3.0001ZM8.87697 9.05919L10.0176 15.3501H18.482L19.6224 9.05919H8.87697Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3296 21.1651C12.3296 22.0847 11.5842 22.8301 10.6646 22.8301C9.74505 22.8301 8.99961 22.0847 8.99961 21.1651C8.99961 20.2455 9.74505 19.5001 10.6646 19.5001C11.5842 19.5001 12.3296 20.2455 12.3296 21.1651Z",
    fill: "#414141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4107 21.1651C19.4107 22.0847 18.6652 22.8301 17.7457 22.8301C16.8261 22.8301 16.0807 22.0847 16.0807 21.1651C16.0807 20.2455 16.8261 19.5001 17.7457 19.5001C18.6652 19.5001 19.4107 20.2455 19.4107 21.1651Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShoppingCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ShoppingCart.4160e45f83d4f0cf72ca3aacb261e087.svg";